import gql from "graphql-tag";

export const LOGIN_USER = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      jwt
    }
  }
`;

export const REVIEW_REPORT = gql`
  mutation reviewAbuseReport(
    $reportId: String!
    $noteToBlag: String!
    $messageToContentCreator: String!
    $messageToReporter: String!
    $blockContent: Boolean!
  ) {
    reviewAbuseReport(
      reportId: $reportId
      noteToBlag: $noteToBlag
      messageToContentCreator: $messageToContentCreator
      messageToReporter: $messageToReporter
      blockContent: $blockContent
    ) {
      noteToBlag
    }
  }
`;
